import { css } from 'lit';

export default css`
  :host([keyboard-open]) {
    --current-header-height: 6rem;
  }
  :host {
    --current-header-height: 18rem;
    width: 100vw;
    max-width: 100vw;
  }
  :host(.header-small) {
   // --current-header-height: 12rem;
  }
  
  ::slotted(lh-header[keyboard-open]) {
    --header-height: 6rem;
  }
  ::slotted(lh-header) {
    --header-height: var(--current-header-height);
    /*filter: unset;*/
    z-index: 1;
  }
  ::slotted(lh-questionnaire) {
    z-index: 0;
    height: calc(var(--maxH, 100vh) - var(--current-header-height));
    position: absolute;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
  }
  ::slotted(lh-questionnaire[isNewLandingPage]) {
    height: auto;
    top: 0;
    bottom: unset;
  }
  :host(.header-high) ::slotted(lh-header) {
      --header-height: 6rem;
      --current-header-height: 6rem;
  }
  :host([keyboard-open]) ::slotted(lh-questionnaire) {
    height: calc(100% - var(--current-header-height));
  }
  :host(.section-changing) {
    --transition-speed: 150ms;
    --current-header-height: 38rem;
  }

  :host([display-mode="summary"]) {
    --current-header-height: 100%;
  }
`;